export enum EntitlementMode {
  System = 'System',
  DataModule = 'DataModule',
  DataEntity = 'DataEntity',
  DataViews = 'DataViews',
}
